import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '@/lib/api';

const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api.get(`/auth/me`);
        setUser(response.data);
      } catch (error) {
        console.error('Failed to fetch user', error);
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const response = await api.post(`/auth/login`, { email, password });
    const { access_token } = response.data;
    localStorage.setItem('token', access_token);
    setToken(access_token);
    
    // Fetch user data immediately after login
    const userResponse = await api.get(`/auth/me`);
    setUser(userResponse.data);
    
    return response.data;
  };

  const register = async (email, password, full_name) => {
    // The server assigns the role (public registration is bootstrap-only), so we
    // never send a client-chosen role.
    const response = await api.post(`/auth/register`, {
      email,
      password,
      full_name
    });
    const { access_token } = response.data;
    localStorage.setItem('token', access_token);
    setToken(access_token);
    
    // Fetch user data immediately after registration
    const userResponse = await api.get(`/auth/me`);
    setUser(userResponse.data);
    
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);